module.exports = __webpack_public_path__ + "img/GraphQL.6987c2c0.png";